import { IGetServerTimeAction } from "@/types/serverTime.types";
import { GET_SERVER_TIME } from "../constants/ActionTypes";
import initialState from "../store/initialState";

const serverTimeReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState.serverTime,
  action: IGetServerTimeAction,
) => {
  switch (action.type) {
    case `${GET_SERVER_TIME}_SUCCESS`:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default serverTimeReducer;
